import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

import Header from "./components/Header";
import MainFlow from "./components/MainFlow";
import VitaminDTracker from "./components/VitaminDTracker";
import RelaxationTool from "./components/RelaxationTool";
import QuickDestressTool from "./components/QuickDestressTool";
import ProtectedRoute from "./components/ProtectedRoute";

export default function App() {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setAuthLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (authLoading) {
    return (
      <div style={{
        textAlign: "center",
        marginTop: "22vh",
        background: "#fffbe6",
        borderRadius: 32,
        maxWidth: 400,
        marginLeft: "auto",
        marginRight: "auto",
        padding: "48px 24px",
        boxShadow: "0 4px 24px rgba(255,209,102,0.10)"
      }}>
        <div
          style={{
            fontSize: 70,
            animation: "sunWiggle 1.8s infinite",
            display: "inline-block"
          }}
        >
          ☀️
        </div>
        <div style={{ marginTop: 24, fontSize: 24, color: "#b48b1e", fontWeight: 700 }}>
          Welcome to Bolo!
        </div>
        <div style={{ marginTop: 12, fontSize: 17, color: "#217a53" }}>
          Your wellness journey is starting...
        </div>
        <div style={{ marginTop: 16, fontSize: 14, color: "#bfa760" }}>
          Loading your personalized experience...
        </div>
        <style>
          {`
            @keyframes sunWiggle {
              0% { transform: rotate(-10deg);}
              20% { transform: rotate(10deg);}
              40% { transform: rotate(-8deg);}
              60% { transform: rotate(8deg);}
              80% { transform: rotate(-5deg);}
              100% { transform: rotate(0deg);}
            }
          `}
        </style>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Header user={user} setUser={setUser} />
      <Routes>
        <Route path="/" element={<MainFlow user={user} />} />
        <Route
          path="/tools/vitamin-d-tracker"
          element={
            <ProtectedRoute user={user}>
              <VitaminDTracker user={user} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tools/relaxation"
          element={
            <ProtectedRoute user={user}>
              <RelaxationTool user={user} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tools/quick-destress"
          element={
            <ProtectedRoute user={user}>
              <QuickDestressTool user={user} />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Analytics />
    </BrowserRouter>
  );
}
